import {
  NavigationProp,
  ParamListBase,
  RouteProp,
} from "@react-navigation/native";
import { ScrollView, StyleSheet, View, Text } from "react-native";
import Observation from "../components/common/Observation";
import { Colors, Spacing, Typography } from "../styles";
import { FontAwesome } from "@expo/vector-icons";
import { Data } from "../types";
import ViewingEntity from "../components/common/ViewingEntity";
import { InsightID } from "../types/data";
import { useSelector } from "react-redux";
import { RootState } from "../redux";
import { selectInsight } from "../redux/mainSlice";

export const Title = () => (
  <View style={[styles.row, styles.title]}>
    <Text style={Typography.title}>Observations</Text>
    <View style={[styles.row, styles.sort]}>
      <Text style={[Typography.paragraph, styles.sortText]}>Date</Text>
      <FontAwesome
        name="long-arrow-down"
        size={12}
        color={Colors.white}
        style={styles.sortIcon}
      />
    </View>
  </View>
);

const Observations = ({
  navigation,
  route,
}: {
  navigation: NavigationProp<ReactNavigation.RootParamList>;
  route: RouteProp<ParamListBase, string>;
}) => {
  const params = route.params as any;
  const id = params.id as InsightID;

  const observations = useSelector((state: RootState) =>
    selectInsight(state, id)
  )?.observations;

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.inner}>
        <ViewingEntity goBack />

        <View style={styles.card}>
          <Title />

          {observations?.map((o) => (
            <Observation
              entity={o.entity}
              text={o.text}
              date={o.date}
              style={{ marginBottom: 10 }}
            />
          ))}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.plum900 },
  inner: {
    padding: Spacing.page,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  card: {
    borderRadius: Spacing.cardRadius,
    padding: Spacing.card,
    backgroundColor: Colors.plum700,
  },
  title: {
    marginBottom: 10,
  },
  sort: { opacity: 0.5 },
  sortText: {
    marginRight: 5,
  },
  sortIcon: {
    marginTop: 2,
  },
});

export default Observations;
